/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import axios from 'axios';
import { SecurityHelper as SecurityUtils } from 'sarsaparilla';
import AxiosRetry from './axiosRetry';

export const campingSearchAxios = (function () {
    const searchAxios = axios.create({});
    AxiosRetry(searchAxios, {
        maxRetries: 3,
    });
    return searchAxios;
})();

export const campingIAPAxios = (function () {
    const iapAxios = axios.create({
        headers: {
            Authorization: SecurityUtils.getAuthHeader(),
        },
    });
    AxiosRetry(iapAxios, {
        maxRetries: 3,
    });
    return iapAxios;
})();
